export default __webpack_public_path__ + "static/media/Kasapuram.a7036c1d.webp";